<template>
  <v-select
    v-model="tariff"
    outlined
    :error-messages="error_messages"
    :loading="loading"
    :disabled="loading"
    label="Chave Pix"
    :items="tariffs"
    item-text="pix_key"
    item-value="id"
  ></v-select>
</template>

<script>
import { mapGetters } from 'vuex'
import axios from '@/plugins/axios'

export default {

  components: {},
  props: {
    value: {},
    error_messages: {},
  },

  data: () => ({
    loading: false,
    tariff: '',
    tariffs: [],
  }),

  watch: {
    value(val) {
      this.tariff = val
    },
    tariff() {
      this.$emit('input', this.tariff)
      this.$emit('change', this.tariff)

      // proucura o objeto correspondente ao id tarriff
      const tariffObject = this.tariffs.find(item => item.id == this.tariff)

      this.$emit('object', tariffObject)
    },

  },

  created() {
    this.tariffs = this.getPixs
    this.tariff = this.value

    // this.loading = true
    // axios
    //     .get('helper/get_room_categorys')
    //     .then(response => {
    //       this.roomCategorys = response.data
    //     })
    //     .finally(() => {
    //         this.loading = false
    //     })
  },
  computed: {
    ...mapGetters('select', ['getPixs']),
  },

  methods: {},
}
</script>
